module.exports = __webpack_public_path__ + "static/media/olympic.35a01e9d.jpg";